// extracted by mini-css-extract-plugin
export default {"bgLightGrey":"style_bgLightGrey__CceZC","bgGrey":"style_bgGrey__siS6E","minHeight":"style_minHeight__Cu1jm","customWidthHeight":"style_customWidthHeight__8q-Xa"};